import * as React from "react";
import * as R from "ramda";
import {Glyphicon, Row} from "react-bootstrap";
import ModalConfirmacion from "../../../general/componentes/ModalConfirmacion";
import {connect} from "react-redux";
import {rechazarDocumentos} from "../../modulos/documentosActions";

class ModarAnular extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        this.setState({show: true});
    }

    render() {
        return (
            <div>
                <Row>
                    <a title={"ANULAR"} className={"btns btns-primary"}
                       onClick={() => this.handleShow()}><Glyphicon glyph={"remove"}/></a>
                </Row>
                <Row>
                    <ModalConfirmacion titulo={"ATENCIÓN"} show={this.state.show}
                                       onCancelar={() => this.handleClose()}
                                       onAceptar={() => this.rechazo()}>
                                        Señor usuario, desde la página usted dio clic a la opción “anular solicitud”,
                                        para poder entregar los documentos debe ingresar nuevamente al formulario en internet y completar todos los pasos.
                                        Recuerde que desde la misma página puede entregar los documentos en forma virtual para que evite mas desplazamientos.
                    </ModalConfirmacion>
                </Row>
            </div>
        );
    }

    rechazo = () => {
        const mensajeObservacion = "El formulario recibido en ARL SURA ya había sido anulado por usted cuando intentó modificarlo en nuestra página después de haberlo finalizado."  
        + "Esta acción no era posible y al continuar, autorizó la anulación."
        + "Si desea reiniciar el proceso de afiliación use el último código de seguridad que recibió y haga clic aquí (va a la elección de formulario)";
        const codigoRechazo = [
            { 
                codigo: "99", 
                descripcion: "ANULADO POR PETICION DE USUARIO",
                observacion : mensajeObservacion
            }
        ];

        this.props.dispatch(rechazarDocumentos(
            this.props.dni,
            this.props.dniLogin,
            this.props.tipoCliente.id,
            codigoRechazo
        ));
    };
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        estadoAccion: R.pathOr("", ["documentos", "estadoAccion"]),
        dniLogin: R.pathOr("", ["inicio", "dniLogin"])(store)
    };
})(ModarAnular);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/ModalAnular.tsx